// BODi custom JavaScript

(function () {
  
  function formatCents(cents) {


    if (window.SezeriumPriceHandler?.formatPrice) return window.SezeriumPriceHandler.formatPrice(cents);

    const currency = window.Shopify?.currency?.active || 'USD';
    return (Number(cents) / 100).toLocaleString(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency,
    });
  }



  function getPriceFormat() {

    const settings = typeof SezeriumAppSettings !== 'undefined' ? SezeriumAppSettings : null;
    const format = settings?.settings?.variantsList?.priceFormat;

    if (typeof format !== 'string') return null;

    // Checks if the format wants price range

    const hasRange = format.includes('{MIN_PRICE}') || format.includes('{MAX_PRICE}');
    return hasRange ? format : null;
  }



  function getCardRange(product, variant, isRange) {
    const hasGroup = variant?.groupMinPrice != null && variant?.groupMaxPrice != null;
    const source = !isRange && hasGroup
      ? { min: variant.groupMinPrice, max: variant.groupMaxPrice }
      : { min: product?.minPrice, max: product?.maxPrice };

    return { min: Number(source.min), max: Number(source.max) };
  }

  // The card shows one variant (usually the cheapest pack), which often has no compare-at
  // while its sibling packs do. Read the highest compare-at across the variants the card
  // groups (or the whole product for range cards) from Sezerium's full product data.
  function getCompareAtMax(product, variant, isRange) {
    const full = window.SezeriumFullProducts?.[product?.id];
    const members = !isRange && Array.isArray(variant?.sortMembers)
      ? new Set(variant.sortMembers.map(String))
      : null;
    const variants = (full?.variants || []).filter((v) => !members || members.has(String(v.id)));

    let max = null;
    variants.forEach((v) => {
      const compare = Number(v.compareAtPrice);
      if (compare > Number(v.price)) max = Math.max(max ?? 0, compare);
    });

    if (max != null) return max;

    const own = Number(variant?.compareAtPrice);
    return own > Number(variant?.price) ? own : null;
  }

  document.addEventListener('sezerium:price:update', (event) => {
    const { el, product, variant, isRange } = event.detail || {};
    if (!el || !product) return;

    const format = getPriceFormat();
    if (!format) return;

    const { min, max } = getCardRange(product, variant, isRange);

    if (!Number.isFinite(min) || !Number.isFinite(max) || !(max > min)) return;

    const text = format
      .replace('{MIN_PRICE}', formatCents(min))
      .replace('{MAX_PRICE}', formatCents(max));

    const compareAt = getCompareAtMax(product, variant, isRange);
    const isOnSale = Number.isFinite(compareAt) && compareAt > min;

    requestAnimationFrame(() => {
      // on sale: struck "min - compare-at" range on the first line, the current range underneath
      if (isOnSale) {
        const containers = el.querySelectorAll('product-price [ref="priceContainer"]');
        if (containers.length) {
          const compareText = format
            .replace('{MIN_PRICE}', formatCents(min))
            .replace('{MAX_PRICE}', formatCents(compareAt));
          const html = `
            <span class="price sezerium-price price--compare-strikethrough" style="display: block; text-decoration: line-through; color: #1C4B76;">${compareText}</span>
            <span class="price bodi-price-range" style="display: block;">${text}</span>
          `;
          containers.forEach((container) => {
            if (container.querySelector('.bodi-price-range')?.textContent.trim() === text) return;
            container.innerHTML = html;
          });
          return;
        }
      }

      let priceEls = el.querySelectorAll('.sezerium-price');
      if (!priceEls.length) priceEls = el.querySelectorAll('.price');

      priceEls.forEach((priceEl) => {
        if (priceEl.textContent.trim() !== text) priceEl.textContent = text;
      });
    });
  });
})();
